/**
 * Fires a function once every {threshold time} and also
 * on the first and last times.
 *
 * @param  {Function} fn         [Function to be fired]
 * @param  {Number}   threshhold [Threshold for firing again]
 * @param  {Object}   scope      [context]
 * @return {Function}            [throttle function]
 */
export default function throttle(fn, threshhold=200, scope) {
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}



// WEBPACK FOOTER //
// ./src/client/utils/throttle.js